// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { GeneratePdfFromTemplateRequest } from './generatePdfFromTemplateRequest.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class GenerateAndSavePdfFromTemplateRequest {
    'type': number;
    'data': GeneratePdfFromTemplateRequest | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof GenerateAndSavePdfFromTemplateRequest>> = [
        {
            "name":     "type",
            "baseName": "type",
            "type":     "number"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "GeneratePdfFromTemplateRequest"
        },
    ];

    static getAttributeTypeMap() {
        return GenerateAndSavePdfFromTemplateRequest.attributeTypeMap;
    }
}
